var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cards",style:({'--per-row': _vm.perRow, '--spacing': _vm.spacing, '--md-per-row': _vm.mdPerRow, '--sm-per-row': _vm.smPerRow, '--xs-per-row': _vm.xsPerRow, 'justify-content': _vm.hAlign, 'align-items': _vm.vAlign})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }